<div class="ltms-feed-detail-panel" [class.show]="OutboxDetailsVisible">
  <div class="ltms-feed-detail-container">
    <div class="ltms-feed-detail-header">
      <div class="left-panel">
        <div class="ltms-feed-detail-tabs">
          <div class="ltms-feed-detail-tab" *ngFor="let tab of tabs"
            [class.active]="activeTab.key === tab.key" (click)="onChangeTab(tab)">
            {{ tab.name }}
          </div>
        </div>
      </div>
      <div class="right-panel">
        <button type="button" class="panel-refresh-btn" title="Refresh"
          *ngIf="selectedChannelDetail?.adhoc_event_id"
          [disabled]="isRefreshing || !selectedChannelDetail?.adhoc_event_id"
          (click)="refreshOutboxDetailPanel()">
          <span class="panel-refresh-loader" *ngIf="isRefreshing"></span>
          <img *ngIf="!isRefreshing" src="assets/images/refresh.svg" alt="Refresh">
        </button>
        <button type="button" (click)="closeOutboxDetailPanel()" title="Close">
          <img src="assets/images/close.svg" alt="Close">
        </button>
      </div>
    </div>
    <div class="ltms-feed-detail-body" *ngIf="activeTab.key === 'attempts'">
      <!-- channel status details- -->
      <div *ngIf="isDataLoaded && trialsData && trialsData.length > 0">
        <ng-container *ngIf="columns.length > 0">
          <app-ltms-data-table-v2 
            *ngIf="showTable"
            [columns]="columns"
            [data]="trialsData"
            [configs]="{ nativeTooltip: true }"
            [errorCode]="'404'">
          </app-ltms-data-table-v2>
        </ng-container>
      </div>
      
      <div class="outbox-loader" *ngIf="!isDataLoaded && !trialsData.length">
        <app-ltms-loader></app-ltms-loader>
      </div>
      <div class="status-info-container ms-2">
        <div class="align-items-center" *ngIf='is_request_expired && isCustomerNotifierServiceEnabled == false'>
          <span> {{expiredAndServiceOFFMsg}}</span>
        </div>
        <div class="align-items-center"
          *ngIf='is_request_expired == false && isCustomerNotifierServiceEnabled == false'>
          <span> {{notExpiredAndServiceOFFMsg}}</span>
        </div>
        <div class="align-items-center" *ngIf='is_request_expired  && isCustomerNotifierServiceEnabled == true'>
          <span> {{expiredAndServiceONMsg}}</span>
        </div>
        <div class="align-items-center"
          *ngIf='is_request_expired == false  && isCustomerNotifierServiceEnabled == true'>
          <span> {{notExpiredAndServiceONMsg}}</span>
        </div>
        <div class="align-items-center"
          *ngIf='is_request_expired == false  && isCustomerNotifierServiceEnabled == true && showWaitMsg == true'>
          <span> {{notExpiredAndServiceONWithWaitMsg}}</span>
        </div>
      </div>
    </div>
    <div *ngIf="activeTab.key === 'attempts' &&
            isDataLoaded &&
            (!trialsData || trialsData.length === 0) &&
            ifUserRatedWithoutTrialDetails.length > 0" class="ms-2 d-flex justify-content-center align-items-center"
      style="height: 100%">
      <div>{{ ifUserRatedWithoutTrialDetails }}</div>
    </div>
    <div class="ltms-feed-detail-body" *ngIf="activeTab.key === 'information'">
      <div class="ltms-feed-detail-tab-panel">
        <app-outbox-information-panel *ngIf="activeTab.key === 'information'" [feedData]="informationFeedData" [feedId]="informationFeedId"
          [brandDetails]="informationBrandDetails" [isNotRespondedTab]="isNotRespondedTab">
        </app-outbox-information-panel>
      </div>
    </div>
  </div>
</div>